import { Grid } from "@mui/material";
import React from "react";
import io from "socket.io-client";
import NavigationDrawer from "../../../components/NavigationDrawer/index";
import ListBox from "./ListBox";
import MessageBox from "./MessageBox";
import { socketUrl } from "../../../services";

const socket = io.connect(socketUrl);

function SupplierCustomerSupport() {
  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={3.5}>
          <ListBox socket={socket} />
        </Grid>
        <Grid
          item
          xs={12}
          md={8.5}
          sx={{ display: { xs: "none", md: "block" } }}
        >
          <MessageBox socket={socket} />
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default SupplierCustomerSupport;
